module.exports = __webpack_public_path__ + "img/medicos.0b1280ea.jpg";